import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GridLocalizationService {
  private http = inject(HttpClient);

  public getLocaleText(): Observable<any> {
    return this.http.get('assets/i18n/ag-grid/messages.json');
  }
}
